import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useGetOperationStatus } from "@/api/dataset/useDatasetAPI";
import NotificationContent from "@/components/notification/notificationContent";
import useToast, { EToastType } from "@/hooks/ui/useToast";
import { OperationStatusType } from "@/types/dataset";

export const useExportAnalysisSummaryStatus = () => {
  const { showToast } = useToast();

  const [operationId, setOperationId] = useState<string | null>(null);

  const { data, refetch } = useGetOperationStatus(operationId || "", {
    enabled: !!operationId,
    refetchInterval: (query) => {
      if (
        query.state.data?.status === OperationStatusType.FAILED ||
        query.state.fetchFailureCount > 3
      ) {
        toast.dismiss();
        showToast({
          type: EToastType.ERROR,
          message: (
            <NotificationContent>
              <p className="mt-1">Exporting summary, please wait...</p>
              <button
                className="mt-1 text-[#4C7DFB] font-semibold cursor-pointer"
                onClick={() => refetch()}
              >
                Try again
              </button>
            </NotificationContent>
          )
        });
        return false;
      } else if (query.state.data?.status === OperationStatusType.SUCCESS)
        return false;

      return 5000;
    },
    staleTime: 0,
    gcTime: 0,
    refetchIntervalInBackground: true
  });

  useEffect(() => {
    if (
      data?.status === OperationStatusType.STARTED ||
      data?.status === OperationStatusType.IN_PROGRESS
    ) {
      toast.dismiss();
      showToast({
        id: "export-summary",
        type: EToastType.LOADING,
        message: (
          <NotificationContent>
            <p className="mt-1">Exporting summary, please wait...</p>
          </NotificationContent>
        )
      });
    } else if (data?.status === OperationStatusType.SUCCESS) {
      toast.dismiss();
      // Download the file from the URL
      if (data?.export_url) {
        window.open(data.export_url, "_blank");
        setOperationId(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return { operationId, setOperationId };
};
